<script lang="ts" context="module">
    export let pendingOpenTask = writable<PracticeAny | null>(null)
</script>

<script lang="ts">
    import type { PracticeAny } from "@circleofa/acim-engine"
    import Popup from "@components/popup/Popup.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import { writable } from "svelte/store"
    import MeditationAudioPopup from "./MeditationAudioPopup.svelte"
    import Button from "@components/button/Button.svelte"
    import ButtonIcon from "@components/button/ButtonIcon.svelte"

    export let practice: PracticeAny
    let infoOpen = false

    $: if ($pendingOpenTask == practice) {
        infoOpen = true
        $pendingOpenTask = null
    }
</script>

<div class="flex justify-between gap-4">
    <div>
        <h4 class="practice-task-title">
            {@html practice.type}
        </h4>
        <p class="practice-task-copy">{@html practice.sentence}</p>
    </div>
    <div class="flex gap-2">
        <Button class="px-2 h-min w-min" color="white" go={() => (infoOpen = true)}>
            <ButtonIcon icon="information" />
        </Button>
        <MeditationAudioPopup {practice} />
    </div>
</div>

{#if infoOpen}
    <Popup on:clickoutside={() => (infoOpen = false)}>
        <PopupExit on:exit={() => (infoOpen = false)} />
        <div class="flex items-center gap-4">
            <MeditationAudioPopup {practice} />
            <PopupHeading class="mb-2">
                <div>
                    <span class="text-sm opacity-60">Lesson {practice.lesson.number}</span><br />
                    {practice.type}
                </div>
            </PopupHeading>
        </div>
        <div class="practice-instruction-content normal-rendering">
            <p class="mb-4">
                {@html practice.temptation ?? practice.instruction}
            </p>
        </div>
    </Popup>
{/if}

<!-- <h4>Type</h4>
{@html practice.type}
<h5>Instructions:</h5>
{@html practice.instruction}
<h5>Remarks:</h5>
{@html practice.remarks}
<h5>Temptation:</h5>
{@html practice.temptation}
<h5>Duration:</h5>
{@html practice.duration}
<h5>Sentence:</h5>
{@html practice.sentence}
<h5>Time:</h5>
{@html practice.time}
<h5>Xmin:</h5>
{@html practice.xmin}
<h5>Xperday:</h5>
{@html practice.xperday} -->

<style>
    .practice-task-title {
        margin: 0 0 0.35rem;
        color: var(--color-purple-900);
        font-family: Lora, ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
        font-size: 1.05rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.3;
    }

    .practice-task-copy {
        margin: 0;
        color: var(--color-grey-600);
        font-size: 0.95rem;
        line-height: 1.65;
    }

    :global(.darkmode) .practice-task-title {
        color: var(--color-grey-50);
    }

    :global(.darkmode) .practice-task-copy {
        color: var(--color-grey-200);
    }

    .practice-instruction-content {
        padding-bottom: 0.1rem;
    }
</style>
